import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet, Router } from '@angular/router';
import { DialogRef } from '../../services/modal.service';
import { I18nTranslator } from '../../i18n/translate';
import { Campaign } from '../../models/campaign.model';
import { Farm } from '../../models/farm.model';
import { Organisation } from '../../models/organisation.model';
import { Page } from '../../models/page.model';
import { CampaignYearPipe } from '../../pipes/campaignYear.pipe';
import { ARGenConsoleService } from '../../services/agrorendement-genconsole.service';
import { CampaignService } from '../../services/campaign.service';
import { FarmService } from '../../services/farm.service';
import { KeycloakService } from '../../services/keycloak.service';
import { OrganisationService } from '../../services/organisation.service';
import { UserService } from '../../services/user.service';
import { PlanningSelectExploitation } from '../planning/planning-exploitation.component';
import { PRODUCT_NAME } from '../../utils/env';
import { ExportsComponent } from './exports';
import { User } from '../../models/user.model';
import { TranslateWithPunctuationPipe, TranslatePipe } from '../../pipes/translate.pipe';
import { FormsModule } from '@angular/forms';
import { PaginationModule } from 'ngx-bootstrap/pagination';

export class ExportSummaryDialogContext {
  parent: ExportsComponent;
  size: string;
}

@Component({
  standalone: true,
  selector: 'export-summary-dlg',
  templateUrl: 'export-summary-dialog.component.html',
  styleUrls: ['export-summary-dialog.component.scss'],
  providers: [UserService, OrganisationService, FarmService, CampaignService, ARGenConsoleService],
  imports: [RouterLink, RouterLinkActive, RouterOutlet, CommonModule, PlanningSelectExploitation, CampaignYearPipe, TranslateWithPunctuationPipe, TranslatePipe, FormsModule, PaginationModule],
})
export class ExportSummaryDialogComponent implements OnInit {
  productName = PRODUCT_NAME;

  @ViewChild(PlanningSelectExploitation)
  private planningSelectExploitation: PlanningSelectExploitation;

  @ViewChildren('farmCheckbox') farmCheckboxes: any;

  @Input('farmIds')
  checkedFarmIds: Set<number> = new Set<number>();

  @Input('farmIdMapping')
  farmIdsNames: Map<number, string>;

  @Input()
  orderItem: Set<Farm>;

  errorMessage: any;
  context: ExportSummaryDialogContext;
  campaigns: Campaign[];

  public campaignFilter: number;
  public isAdmin: boolean;

  farms = new Array<Farm>();
  farmIds = new Set<number>();
  objectList: Map<number, string>;
  organisation: Array<Organisation> = [];
  userInfo: User;
  campaignExportId: number;

  public successMessage: string = '';
  public showSuccessMessage: boolean = false;
  public rows: Array<any> = [];
  public filteredRows: Array<any> = [];
  public filterText: string = '';

  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;

  static filterToApply: string;
  static filterOrgaToApply: string;
  static filterAdvisorToApply: string;

  isDownloadButtonEnabled: boolean = false;

  constructor(
    public dialog: DialogRef<ExportSummaryDialogContext>,
    private campaignService: CampaignService,
    private exportsService: ARGenConsoleService,
    private farmService: FarmService,
    private i18nTranslator: I18nTranslator,
    private userService: UserService,
    private router: Router,
  ) {
    this.context = dialog.context;
    this.isAdmin = KeycloakService.auth.authz.hasRealmRole('ROLE_ADMIN');
    this.farmIdsNames = new Map<number, string>();
  }

  ngOnInit() {
    this.campaignService.getCampaigns().subscribe((x) => {
      this.handleCampaigns(x);
    });
    ExportSummaryDialogComponent.filterToApply = undefined;
    this.fetchUserData();
  }

  isCheckboxAllChecked(): boolean {
    return null;
  }

  isFarmChecked(farm_id): boolean {
    return this.checkedFarmIds.has(farm_id);
  }

  updateDownloadButtonState() {
    // Enable/disable the download button based on whether any checkbox is checked
    this.isDownloadButtonEnabled = this.checkedFarmIds.size > 0;
  }

  onCheckboxClicked(farmId: number, event: any) {
    if (event.target.checked) {
      this.checkedFarmIds.add(farmId);
      const farm = this.rows.find((f) => f.id === farmId);
      if (farm) {
        this.farmIdsNames.set(farm.id, farm.name);
      }
    } else {
      this.checkedFarmIds.delete(farmId);
      this.farmIdsNames.delete(farmId);
    }

    this.updateDownloadButtonState();
  }

  handleCampaigns(campaigns: Campaign[]) {
    this.campaigns = campaigns.sort(Campaign.compare).reverse();

    if (this.campaigns.length > 0) {
      this.campaignExportId = this.campaigns[0].id;
      console.log('Selected Campaign ID:', this.campaignExportId);
      this.onChangeTable();
    }
  }

  getFarmsPaginated(
    pageIndex: number,
    sortColumnName: string,
    sortColumnOrder: string,
    filter: any,
    filterOrga: string,
    campaignId: number,
  ) {
    console.log('getting farms');
    this.farmService
      .getFarmsAdvanced(
        pageIndex,
        this.itemsPerPage,
        sortColumnName,
        sortColumnOrder,
        filter,
        filterOrga,
        null,
        campaignId,
      )
      .subscribe((page) => this.handlePage(page));
  }

  private fetchUserData() {
    this.userService.getMe().subscribe(
      (data) => {
        this.userInfo = data;
      },
      (error) => {
        console.error('Error fetching user data', error);
      },
    );
  }

  handlePage(page: Page<Farm>) {
    this.rows = page.content;
    this.numPages = page.totalPages;
    this.length = page.totalElements;
    this.filterRows(); // Apply filter if there is any
  }

  onCampaignChange() {
    console.log('Selected Campaign ID:', this.campaignExportId);
    this.page = 1;
    this.onChangeTable();
  }

  onChangeTable(page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    console.log('calling onchageTable...');
    const pageNumber = page.page;
    const filter = {
      filter: ExportSummaryDialogComponent.filterToApply,
      filterAdvisor: ExportSummaryDialogComponent.filterAdvisorToApply,
    };
    this.getFarmsPaginated(
      pageNumber,
      null,
      null,
      filter,
      ExportSummaryDialogComponent.filterOrgaToApply,
      this.campaignExportId,
    );
  }

  filterRows() {
    if (!this.filterText) {
      this.filteredRows = this.rows; // Show all rows if filter text is empty
    } else {
      this.filteredRows = this.rows.filter((row) => row.name.toLowerCase().includes(this.filterText.toLowerCase()));
    }
  }

  downloadSummary() {
    const checkedFarmIdsArray = Array.from(this.checkedFarmIds);
    const genericErrorMessage = this.i18nTranslator.translate('exports.summary.error');
    const conflictErrorMessage = this.i18nTranslator.translate('exports.summary.conflict.error');
    const userToSendId = this.userInfo.id;

    this.exportsService
      .generateConsoleSummary(this.campaignExportId.toString(), checkedFarmIdsArray, userToSendId.toString())
      .subscribe(
        (response: any) => {
          if (response.ok) {
            const successMessageTemplate = this.i18nTranslator.translate('exports.summary.user.message');
            this.successMessage = successMessageTemplate.replace('#mailuser', this.userInfo.email2);
            this.showSuccessMessage = true;
          } else {
            this.handleError(genericErrorMessage);
          }
        },
        (error) => {
          if (error.status === 409) {
            console.error('Conflict error generating summary', error);
            this.handleError(conflictErrorMessage.replace('{email}', this.userInfo.email2));
          } else {
            console.error('Error generating summary', error);
            this.handleError(genericErrorMessage);
          }
        },
      );
  }

  handleError(error: any) {
    this.errorMessage = error;
  }

  dismiss() {
    this.dialog.close();
  }

  closeWithSuccess() {
    this.dialog.close(true);
  }

  applyFilterKeyUp(event: KeyboardEvent) {
    ExportSummaryDialogComponent.filterToApply = (event.target as HTMLInputElement).value;

    this.page = 1; // Reset to the first page when applying a new filter

    const filter = {
      filter: ExportSummaryDialogComponent.filterToApply,
      filterAdvisor: ExportSummaryDialogComponent.filterAdvisorToApply,
    };

    this.getFarmsPaginated(
      this.page,
      null,
      null,
      filter,
      ExportSummaryDialogComponent.filterOrgaToApply,
      this.campaignExportId,
    );
  }
}
